import { useWizardTour } from './useWizardTour'
import { useDashboardTour } from './useDashboardTour'

interface UsePlanningTourProps {
  currentStep: number
  isDarkMode: boolean
  mode: 'view' | 'create' | 'edit'
  hasPlans: boolean
}

/**
 * Main hook to manage all tours in the Planning page
 * Combines wizard tour and dashboard tour logic
 */
export const usePlanningTour = ({
  currentStep,
  isDarkMode,
  mode,
  hasPlans,
}: UsePlanningTourProps) => {
  const wizardTour = useWizardTour({
    currentStep,
    isDarkMode,
    mode,
    hasPlans,
  })

  const dashboardTour = useDashboardTour({
    isDarkMode,
    mode,
    hasPlans,
  })

  return {
    wizardTour,
    dashboardTour,
  }
}
